import LoadingSpinner from '@app/components/LoadingSpinner';

interface CenterLoadingSpinnerProps {
  color: 'black' | 'white' | 'gray';
  size: number;
  testId?: string;
}

const defaultProps = {
  color: 'black',
  size: 50,
};

function CenterLoadingSpinner({ color, size, testId }: CenterLoadingSpinnerProps) {
  const marginOffset = -(size / 2);
  return (
    <LoadingSpinner
      color={color}
      size={size}
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        margin: `${marginOffset}px 0 0 ${marginOffset}px`,
      }}
      testId={testId}
    />
  );
}

CenterLoadingSpinner.defaultProps = defaultProps;

export default CenterLoadingSpinner;
